import axios from "../../../common/config/axios";
import * as types from "./types";

export const getSettlementList = (data) => (dispatch, getState) => {
    data.country_id = getState().currentUser.data.country_id;
    axios.get('settlement/list', { params: data })
    .then((res) => {
        dispatch({
            type: types.SETTLEMENT_LIST,
            payload: res.data
        });
    })
    .catch((err) => {

    });
};

export const getSettlementDropdown = (data) => (dispatch, getState) => {
    data.country_id = getState().currentUser.data.country_id;
    axios.get('settlement/dropdown', { params: data })
    .then((res) => {
        dispatch({
            type: types.SETTLEMENT_DROPDOWN,
            payload: res.data
        });
    })
    .catch((err) => {

    });
};

export const getSettlementBalance = (data) => (dispatch, getState) => {
    data.country_id = getState().currentUser.data.country_id;
    axios.get('settlement/balance', { params: data })
    .then((res) => {
        dispatch({
            type: types.SETTLEMENT_BALANCE,
            payload: res.data
        });
    })
    .catch((err) => {

    });
};

export const createSettlement = (data) => (dispatch, getState) => {
    data.country_id = getState().currentUser.data.country_id;
    axios.post('settlement/create', data)
    .then((res) => {
        dispatch({
            type: types.SETTLEMENT_CREATE,
            payload: res.data
        });
    })
    .catch((err) => {

    });
};